import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, reactive, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidInputNumber',
  props: {
    valid: { type: Function },
    value: {}
  },
  setup(__props: any) {


const props = __props
const info = reactive({open: false, title: '', status: ''})
watch(() => props.value, (v) => onChange(v))
const onChange = (v: number) => {
  const msg = props.valid(v)
  if (msg) {
    info.status = 'error'
    info.open = true
    info.title = msg
  } else {
    info.open = false
    info.status = ''
    info.title = ''
  }
}
onMounted(() => {
  onChange(props.value)
})

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    open: info.open,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((info.open) = $event)),
    title: info.title,
    placement: "right"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input_number, _mergeProps(_ctx.$attrs, {
        value: props.value,
        status: info.status
      }), null, 16, ["value", "status"])
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})